import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
// context
import { loginUser, useUserDispatch } from "../../context/UserContext";
// styles
import useStyles from "./styles";

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [loginValue, setLoginValue] = useState("admin");
  var [passwordValue, setPasswordValue] = useState("123");

  return (
    <Grid container className={classes.container}>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <React.Fragment>
            <TextField
              id="email"
              InputProps={{
                style: { background: "#fff" }
              }}
              value={loginValue}
              onChange={(e) => setLoginValue(e.target.value)}
              margin="normal"
              label="نام کاربری"
              type="text"
              variant="outlined"
            />

            <TextField
              id="password"
              InputProps={{
                style: { background: "#fff" }
              }}
              value={passwordValue}
              onChange={(e) => setPasswordValue(e.target.value)}
              margin="normal"
              label="رمز ورود"
              type="password"
              variant="outlined"
            />
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <Button
                  disabled={
                    loginValue.length === 0 || passwordValue.length === 0
                  }
                  onClick={() =>
                    loginUser(
                      userDispatch,
                      loginValue,
                      passwordValue,
                      props.history,
                      setIsLoading,
                    )
                  }
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  ورود
                </Button>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
